import { useApolloClient, ApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import Cookies from 'universal-cookie';

import { TOKEN_NAME } from './useAuthManagement';

/**
 * logout by removing the cookie and Apollo cache
 * @param authToken authToken
 */
const logoutAndRefresh = async ({
  apolloClient,
}: {
  apolloClient: ApolloClient<object>;
}) => {
  // TODO: consolidate me with useCookie Hook, and manage auth cookie from single scope
  const cookies = new Cookies();
  cookies.remove(TOKEN_NAME, { path: '/' });
  // reset Apollo cache and remove cookie to logout
  // https://stackoverflow.com/questions/48887480/reset-store-after-logout-with-apollo-client
  apolloClient.clearStore();
  apolloClient.cache.reset().then(() => {
    window.location.replace('/');
  });
};

export const useLogoutAndRefresh = (): {
  logout: () => Promise<void>;
} => {
  const apolloClient = useApolloClient();

  const logout = useCallback(async () => {
    // do NOT import useAuthManagement / useCookies here.
    // for some reason, importing useCookies (unless it's a <Drawer> component)
    // causes Apollo to use cached cookies when submitting a request.
    // this causes an `invalid login` error on a page refresh before
    // using the new auth token that got generated from the login
    await logoutAndRefresh({ apolloClient });
  }, [apolloClient]);

  return { logout };
};
